import React, { FC, memo } from 'react';
import { Space, TreeSelect } from 'udesk-ui';
import AgentGroupSelect from 'src/components/common/AgentGroupSelect';
import AgentDepartmentSelect from 'src/components/common/AgentDepartmentSelect';
import AgentSelect from 'src/components/common/AgentSelect';

interface TemplateProps {
    value?: {
        agentGroups?: number[];
        agentDepartments?: number[];
        agents?: number[];
    };
    onChange?: (value: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    return (
        <Space>
            <AgentGroupSelect
                style={{ width: 200 }}
                multiple
                value={value?.agentGroups}
                onChange={(v) =>
                    onChange?.({
                        ...value,
                        agentGroups: v,
                        agents: undefined,
                    })
                }
                maxTagCount={1}
                treeCheckable
                showCheckedStrategy={TreeSelect.SHOW_ALL}
            />

            <AgentDepartmentSelect
                style={{ width: 200 }}
                multiple
                value={value?.agentDepartments}
                onChange={(v) =>
                    onChange?.({
                        ...value,
                        agentDepartments: v,
                        agents: undefined,
                    })
                }
                maxTagCount={1}
                treeCheckable
                showCheckedStrategy={TreeSelect.SHOW_ALL}
            />

            <AgentSelect
                style={{ width: 200 }}
                mode="multiple"
                agentGroupIds={value?.agentGroups}
                agentDepartmentIds={value?.agentDepartments}
                value={value?.agents}
                onChange={(v) => {
                    onChange?.({
                        ...value,
                        agents: v,
                    });
                }}
                maxTagCount={1}
            />
        </Space>
    );
});

export default Template;
